module.exports = __webpack_public_path__ + "static/media/3arsfabspread.e17eaead.jpg";